export default __webpack_public_path__ + "static/media/qrcode-mm.86daa4c1.jpg";